/* eslint-disable react-hooks/rules-of-hooks, react-hooks/exhaustive-deps */
import * as React from 'react';
export function useControlledRef(_ref) {
  let {
    controlled,
    default: defaultValue
  } = _ref;
  const {
    current: isControlled
  } = React.useRef(controlled !== undefined);
  const valueRef = React.useRef(defaultValue);
  if (isControlled) {
    valueRef.current = controlled;
  }
  const setValue = React.useCallback(newValue => {
    valueRef.current = newValue;
  }, []);
  return [valueRef, setValue];
}